import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import { useState } from "react";
import $ from "jquery";
import loader from '.././loader.gif'

function Contact() {

  const [result, setResult] = useState("");
  $('#loader').hide();


  const handleSumbit = (e) => {
    $('#loader').show();
    e.preventDefault();
    // document.getElementById("#form").reset();
    const form = $(e.target);
    $.ajax({
      type: "POST",
      url: form.attr("action"),
      data: form.serialize(),
      success(data) {
        $('#loader').hide();
        document.getElementById("form1").reset();
        setResult(data);
      },
    });
  };
  return (
    <>
      <Breadcrumb title={"Contact Us"} tag="Contact Us" />


      {/* <!--contact us promo start--> */}
      <section className="contact-us-promo pt-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="card single-promo-card single-promo-hover text-center shadow-sm">
                <div className="card-body py-5">
                  <div className="pb-2">
                    <span className="ti-mobile icon-sm color-secondary"></span>
                  </div>
                  <div><h5 className="mb-0">Call Us</h5>
                    <p className="text-muted mb-0">+91 99203 41097</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="card single-promo-card single-promo-hover text-center shadow-sm">
                <div className="card-body py-5">
                  <div className="pb-2">
                    <span className="ti-location-pin icon-sm color-secondary"></span>
                  </div>
                  <div><h5 className="mb-0">Visit Us</h5>
                    <p className="text-muted mb-0">Mumbai, Maharashtra, India</p></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="card single-promo-card single-promo-hover text-center shadow-sm">
                <div className="card-body py-5">
                  <div className="pb-2">
                    <span className="ti-email icon-sm color-secondary"></span>
                  </div>
                  <div><h5 className="mb-0">Mail Us</h5>
                    <p className="text-muted mb-0">info@octaveinfosys.com</p></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="card single-promo-card single-promo-hover text-center shadow-sm">
                <div className="card-body py-5">
                  <div className="pb-2">
                    <span className="ti-headphone-alt icon-sm color-secondary"></span>
                  </div>
                  <div><h5 className="mb-0">Live Chat</h5>
                    <p className="text-muted mb-0"><a href=" https://api.whatsapp.com/send?phone=+919920341097&amp;text=Hello" style={{ color: ' #6c757d' }}>Chat with Us 24/7</a></p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--contact us promo end--> */}

      {/* <!--contact us section start--> */}
      <section className="contact-us-section ptb-100">
        <div className="container contact">
          <div className="col-12 pb-3 message-box d-none">
            <div className="alert alert-danger"></div>
          </div>
          <div className="row justify-content-around">
            <div className="col-md-6">
              <div className="contact-us-form gray-light-bg rounded p-5">
                <h4>Ready to get started?</h4>
                <center><div id="success">{result}</div></center>
                <form action="https://octaveinfosys.com/php/server.php"
                  className="contact-us-form"
                  method="post"
                  id='form1'
                  onSubmit={(event) => handleSumbit(event)} >
                  <div className="form-row">
                    <div className="col-12">
                      <div className="form-group">
                        <input type="text" className="form-control" id="name" name="name" placeholder="Enter name" required="required" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <input type="number" className="form-control" id="phone" name="phone" placeholder="Enter Phone Number" required="required" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <input type="email" className="form-control" id="email" name="email" placeholder="Enter email" required="required" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <textarea name="message" id="message" className="form-control" rows="4" cols="25" placeholder="Message"></textarea>
                      </div>
                    </div>
                    <div className="col-sm-12 mt-3">
                    <button className="btn secondary-solid-btn" type="submit">Submit</button>
                      <img src={loader} alt="loader" style={{ width: 55, height: 55, verticalAlign: 'bottom', display: 'none' }} id="loader"></img>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-5">
              <div className="contact-us-content">
                <h2>Looking for a excellent Business idea?</h2>
                <p className="lead">Request a call back to create a corporate website, a portal, an ecommerce website for selling online or to make your website rank higher in search engine.</p>

                <hr className="my-5" />

                <h5>Our Office</h5>
                <address>
                  Mulund West Mumbai-400080  <br />
                  (India)
                </address>
                <br />
                <span>Phone: +919920341097 | 8080555597</span> <br />
                <span>Email: <a href="mailto:info@octaveinfosys.com" className="link-color">info@octaveinfosys.com</a></span>

              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--contact us section end--> */}

      {/* <!--google map block start--> */}
      <div className="google-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3768.613600731903!2d72.94853!3d19.168384!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd8fc0fd4b8e5d80!2soctave%20infosys%20(website%20Design%20Thane%20%7C%20Mumbai)!5e0!3m2!1sen!2sin!4v1634054966670!5m2!1sen!2sin" title="myFrame" height="450" style={{ border: 0 }} allowFullScreen=""></iframe>
      </div>
      {/* <!--google map block end--> */}

    </>
  )
}

export default Contact
